<template>
  <component :is="componentType" :to="to" class="dropdown-item">
    <slot></slot>
  </component>
</template>
<script>
export default {
  name: 'nav-link',
  inject: ['closeNavbar'],
  props: {
    to: {
      type: [String, Object],
      default: undefined,
    },
  },
  computed: {
    componentType() {
      return this.to ? 'router-link' : 'a';
    },
  },
  methods: {
    teste() {
      console.log('222----------->', this.closeNavbar);
    },
    removeClass() {
      let htmlClasses = document.querySelector('html').classList;

      htmlClasses.remove('nav-open');
    },
    closeNav() {
      this.removeClass();
      console.log('----------->');
      console.log(this.closeNavbar);
      if (this.closeNavbar) {
        this.closeNavbar();
      }
      if (this.closeDropDown) {
        this.closeDropDown();
      }
    },
  },
};
</script>
<style></style>
